import React from 'react'
import {GetModuleFilter} from '../../../hoteleria/features/modules/models'
import {selectMapperByKeys} from '../../mappers/util'
import {useHoteleriaServices} from './useHoteleriaServices'

export const useModules = () => {
  const [loading, setLoading] = React.useState(false)
  const [modules, setModules] = React.useState<{value: string; label: string}[] | any[]>([])
  const {getModules} = useHoteleriaServices()

  const getModulesFn = async (
    filters: GetModuleFilter,
    options: {all: boolean; value: any; label: string} = {all: false, value: null, label: 'TODOS'},
  ) => {
    try {
      setLoading(true)
      const modules = await getModules(filters)
      const mappedModules = selectMapperByKeys(modules, 'Id', 'Codigo')
      let filteredData = mappedModules.filter((item) => item.value !== '4EsB2NAAsDA=')
      if (options.all && filteredData.length > 0) {
        filteredData = [{value: options.value, label: options.label}, ...filteredData]
        setModules(filteredData)
        return filteredData
      } else {
        setModules(filteredData)
        return filteredData
      }
    } catch (error) {
      console.error('Error fetching modules:', error)
    } finally {
      setLoading(false)
    }
  }

  const getModulesDataFn = async (filters: GetModuleFilter) => {
    try {
      setLoading(true)
      const modules = await getModules(filters)
      const mappedModules = modules?.map((m) => ({
        value: m.Id,
        label: m.Codigo,
        ...m,
      }))
      let filteredData = mappedModules?.filter((mm) => mm.value !== '4EsB2NAAsDA=')
      setModules(filteredData)
      return filteredData
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const clearModules = () => {
    setModules([])
  }

  return {
    loading,
    modules,
    getModules: getModulesFn,
    getModulesData: getModulesDataFn,
    clearModules,
  }
}
